import $ from "jquery";
import { netwerkInitMap, networkDataAttributeBuilder } from "./mapHelper";

let mapSplideInstance = null;

/**
 * Generates active search tags
 */
export const searchBubble = () => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);

  const params = new URLSearchParams(url.search);
  const existingTags = params.get("tags");
  const existingDates = params.get("dates");
  const existingKeywords = params.get("keywords");
  const existingTagsArray = existingTags ? existingTags.split(",") : [];
  const existingDatesArray = existingDates ? existingDates.split(",") : [];

  let html = "";
  let hasFilter = false;
  // console.log("yyy", existingTagsArray);
  if (existingTags) {
    existingTagsArray.forEach((tag) => {
      html += `<div class="activeFilterBubble">${tag} <span class="removeFilter" data-value="${tag}">x</span></div>`;
    });
    hasFilter = true;
  }
  if (existingKeywords) {
    html += `<div class="activeFilterBubble">${existingKeywords} <span class="removeFilter" data-value="${existingKeywords}">x</span></div>`;
    hasFilter = true;
  }
  if (existingDatesArray.length > 0) {
    existingDatesArray.forEach((date) => {
      // console.log({ date });
      const formattedDate = dayjs.unix(date).format("MMM 'YY");
      html += `<div class="activeFilterBubble">${formattedDate} <span class="removeFilter" data-value="${date}">x</span></div>`;
    });
    hasFilter = true;
  }
  if (hasFilter) {
    html +=
      '<div class="clearAllFilter" tabindex="0" role="button">WIS ALLE FILTERS</div>';
  }
  $(".searchbubble").html(html);
};

/**
 * Removes item from the filter list in the url
 */
export const removeFilterFromURL = (wordToRemove) => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const params = new URLSearchParams(url.search);

  for (const [key, value] of params) {
    // console.log("hi");
    console.log({ key });
    // Split the value by commas to handle multiple values
    const values = value.split(",");
    console.log({ values });

    // Filter out the word you want to remove
    const filteredValues = values.filter((v) => v !== wordToRemove.toString());

    // Join the filtered values back into a single string
    const filteredValue = filteredValues.join(",");
    console.log({ filteredValue });

    // Set the updated value back in the URLSearchParams
    params.set(key, filteredValue);
    url.search = params.toString();
  }

  // const updatedSearch = params.toString();

  // Update the URL search with the modified parameters
  history.replaceState(null, null, url.toString());
  searchBubble();
};

/**
 * grab the actual filter form the URL
 * @returns
 */
export const getFilterFromURL = () => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);

  let filter = {};

  const params = new URLSearchParams(url.search);
  const existingTags = params.get("tags");
  const existingDates = params.get("dates");
  const existingKeywords = params.get("keywords");

  if (existingTags) {
    const tagsToArray = existingTags ? existingTags.split(",") : [];
    const newTagArray = [];
    tagsToArray.forEach((tag) => {
      newTagArray.push(tag);
    });
    filter.tags = newTagArray;
  }

  if (existingDates) {
    const datetoArray = existingDates ? existingDates.split(",") : [];
    const newDateArray = [];
    datetoArray.forEach((date) => {
      newDateArray.push(dayjs.unix(date).format("MM-YYYY"));
    });
    filter.dates = newDateArray;
  }

  if (existingKeywords) {
    filter.keywords = existingKeywords;
  }

  return filter;
};

export const tagsBubble = () => {
  var hasFilter = false;
  const tags = sessionStorage.getItem("networktags");
  const search = sessionStorage.getItem("networksearchtags");
  const thema = sessionStorage.getItem("thematags");
  const themagratistags = sessionStorage.getItem("themagratistags");

  let html = "";

  if (tags) {
    const jsonTags = JSON.parse(tags);
    // console.log("xxx", jsonTags.tags); // This will output: ["booyah"]
    if (jsonTags.tags.length > 0) {
      hasFilter = true;
      jsonTags.tags.forEach((tag) => {
        html += `<div class="activeFilterBubble !inline-block mt-4 removeFilterNetwork cursor-pointer" data-expertise="${tag}" tabindex="0">${tag} <span class="">x</span></div>`;
      });
    }
  } else {
    sessionStorage.setItem("networktags", JSON.stringify({ tags: [] }));
  }

  if (thema) {
    const jsonTags = JSON.parse(thema);
    // console.log("xxx", jsonTags.tags); // This will output: ["booyah"]
    if (jsonTags.thema.length > 0) {
      hasFilter = true;
      // jsonTags.thema.forEach((tag) => {
      //   html += `<div class="activeFilterBubble !inline-block mt-4">${tag} <span class="removeFilterThema cursor-pointer" data-thema="${tag}">x</span></div>`;
      // });
    }
  } else {
    sessionStorage.setItem("thematags", JSON.stringify({ thema: [] }));
  }

  if (search) {
    html += `<div class="activeFilterBubble !inline-block mt-4 removeSearchNetwork cursor-pointer" data-search="${search}" tabindex="0">${search} <span class="">x</span></div>`;
    hasFilter = true;
  } else {
    sessionStorage.setItem("networksearchtags", "");
  }

  if (themagratistags) {
    // html += `<div class="activeFilterBubble !inline-block mt-4 removeFilterGratis cursor-pointer" tabindex="0">Gratis <span class="">x</span></div>`;
    hasFilter = true;
  }
  else {
    sessionStorage.setItem("themagratistags", "");
  }

  if (hasFilter) {
    html +=
      '<div class="clearAllFilterNetwork !inline-block mt-4" tabindex="0" role="button">WIS ALLE FILTERS</div>';
  }

  const tagsBubbleElement = document.querySelectorAll(".tagsbubble");

  tagsBubbleElement.forEach((element) => {
    element.innerHTML = html;
  });

  clearAllFilterNetwork();
  removeFilterNetwork();
  lookForFilteredNetworks();
  removeSearchNetwork();
  removeFilterGratis();
  return;
};

/**
 * Clears all filter network
 */
export const clearAllFilterNetwork = () => {
  const clearAllFilterNetworkElement = document.querySelectorAll(
    ".clearAllFilterNetwork"
  );
  const searchInput = document.getElementById("searchQueryInput");

  if (clearAllFilterNetworkElement) {
    clearAllFilterNetworkElement.forEach((element) => {
      const clearFilters = () => {
        const tags = sessionStorage.getItem("networktags");
        const themas = sessionStorage.getItem("thematags");
        const jsonTags = JSON.parse(tags);
        const jsonThemas = JSON.parse(themas);

        const checkboxes = document.querySelectorAll(".thematag");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        jsonTags.tags = [];
        jsonThemas.thema = [];
        sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
        sessionStorage.setItem("thematags", JSON.stringify(jsonThemas));
        sessionStorage.setItem("networksearchtags", "");

        if (searchInput) {
          searchInput.value = "";
        }

        sessionStorage.setItem("themagratistags", "");
        const gratisCheckbox = document.getElementById("thema-gratis");
        if (gratisCheckbox) gratisCheckbox.checked = false;

        tagsBubble();
        netwerkInitMap();
        resetFilteredNetwork();
      };

      element.addEventListener("click", clearFilters);

      element.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          clearFilters();
        }
      });
    });
  }
};

export const resetFilteredNetwork = () => {
  const buttonElement = document.getElementById("dropdownMenuMap");

  if (buttonElement === null) { return; }

  buttonElement.textContent = "Kies een wijk";

  const newNetworks = [];
  const networks = document.querySelectorAll(".netwerk-info");
  networks.forEach((network) => {
    let colour = network.getAttribute("data-colour");
    const initialColour = network.getAttribute("data-colour");

    // switch (colour) {
    //   case "rgba(166, 144, 108, 0.5)":
    //     colour = "#A6906C"; //gold
    //     break;
    //   case "rgba(7, 137, 65, 0.5)": //green
    //     colour = "#078941";
    //     break;
    //   case "rgba(23, 94, 199, 0.5)": //blue
    //     colour = "#175EC7";
    //     break;
    //   case "rgba(201, 76, 4, 0.5)": //orange
    //     colour = "#C94C04";
    //     break;
    //   case "rgba(66, 17, 74, 0.5)": //dark purple
    //     colour = "#42114A";
    //     break;
    //   case "rgba(140, 78, 55, 0.5)": //brown
    //     colour = "#8C4E37";
    //     break;
    //   case "rgba(147, 94, 181, 0.5)": //purple
    //     colour = "#935EB5";
    //     break;
    //   case "rgba(213, 36, 165, 0.5)": //pink
    //     colour = "#D524A5";
    //     break;
    //   case "rgba(0, 0, 0, 0.5)": //black
    //     colour = "#000000";
    //     break;
    //   default:
    //     colour = initialColour;
    //     break;
    // }
    // network.setAttribute("data-colour", colour);

    // if (isRGBA(colour)) {
    //   var newColour = rgbaToHex(colour);
    //   network.setAttribute("data-colour", newColour);
    // }
    // else {
    //   colour = initialColour;
    //   network.setAttribute("data-colour", colour);
    // }

    newNetworks.push(network);
  });
  // console.log("its in resetFilteredNetwork")
  listFilteredNetworkInformation(newNetworks);
};

/**
 *
 */
export const removeFilterNetwork = () => {
  const removeFilterNetworkElement = document.querySelectorAll(
    ".removeFilterNetwork"
  );
  const removeFilterThemaElement =
    document.querySelectorAll(".removeFilterThema");
  removeFilterNetworkElement.forEach((networkTag) => {
    networkTag.addEventListener("click", function () {
      const tags = sessionStorage.getItem("networktags");
      const jsonTags = JSON.parse(tags);
      const expertise = networkTag.getAttribute("data-expertise");
      // console.log("xxx click");
      // Remove the expertise tag from the jsonTags.tags array
      jsonTags.tags = jsonTags.tags.filter((tag) => tag !== expertise);

      // Save the updated jsonTags to sessionStorage
      sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
      tagsBubble();
    });
    networkTag.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        const tags = sessionStorage.getItem("networktags");
        const jsonTags = JSON.parse(tags);
        const expertise = networkTag.getAttribute("data-expertise");
        // console.log("xxx click");
        // Remove the expertise tag from the jsonTags.tags array
        jsonTags.tags = jsonTags.tags.filter((tag) => tag !== expertise);

        // Save the updated jsonTags to sessionStorage
        sessionStorage.setItem("networktags", JSON.stringify(jsonTags));
        tagsBubble();
      }
    });
  });
  removeFilterThemaElement.forEach((themaTag) => {
    themaTag.addEventListener("click", function () {
      const tags = sessionStorage.getItem("thematags");
      const jsonTags = JSON.parse(tags);
      const themas = themaTag.getAttribute("data-thema");
      // console.log("xxx click");
      // Remove the expertise tag from the jsonTags.tags array
      jsonTags.thema = jsonTags.thema.filter((thema) => thema !== themas);

      // Save the updated jsonTags to sessionStorage
      sessionStorage.setItem("thematags", JSON.stringify(jsonTags));
      tagsBubble();
    });

    themaTag.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        const tags = sessionStorage.getItem("thematags");
        const jsonTags = JSON.parse(tags);
        const themas = themaTag.getAttribute("data-thema");
        // console.log("xxx click");
        // Remove the expertise tag from the jsonTags.tags array
        jsonTags.thema = jsonTags.thema.filter((thema) => thema !== themas);

        // Save the updated jsonTags to sessionStorage
        sessionStorage.setItem("thematags", JSON.stringify(jsonTags));
        tagsBubble();
      }
    });
  });
};

export const removeSearchNetwork = () => {
  const removeSearchFilter = document.querySelectorAll(".removeSearchNetwork");
  const searchInput = document.getElementById("searchQueryInput");

  removeSearchFilter.forEach((search) => {
    search.addEventListener("click", function () {
      sessionStorage.setItem("networksearchtags", "");
      if (searchInput) {
        searchInput.value = "";
      }
      tagsBubble();
    });

    search.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        sessionStorage.setItem("networksearchtags", "");
        if (searchInput) {
          searchInput.value = "";
        }
        tagsBubble();
      }
    });
  });
};

export const removeFilterGratis = () => {
  const removeFilterGratisElem = document.querySelectorAll(".removeFilterGratis");
  removeFilterGratisElem.forEach((el) => {
    el.addEventListener("click", function () {
      sessionStorage.setItem("themagratistags", "");
      const gratisCheckbox = document.getElementById("thema-gratis");
      if (gratisCheckbox) gratisCheckbox.checked = false;
      tagsBubble();
      lookForFilteredNetworks();
    });
    el.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        sessionStorage.setItem("themagratistags", "");
        const gratisCheckbox = document.getElementById("thema-gratis");
        if (gratisCheckbox) gratisCheckbox.checked = false;
        tagsBubble();
        lookForFilteredNetworks();
      }
    });
  });
};

/**
 * the actual function to look for filtered network
 *
 */

export const lookForFilteredNetworks = () => {
  const networks = document.querySelectorAll(".netwerk-info");
  const tags = sessionStorage.getItem("networktags");
  const themas = sessionStorage.getItem("thematags");
  const search = sessionStorage.getItem("networksearchtags");
  const jsonTags = JSON.parse(tags);
  const jsonThemas = JSON.parse(themas);
  const selectedTags = jsonTags.tags || [];
  const selectedThemas = jsonThemas.thema || [];
  const searchTerm = (search || "").trim().toLowerCase();
  const gratisFilter = sessionStorage.getItem("themagratistags") === "1";

  // Show all if nothing is selected
  if (
    selectedTags.length === 0 &&
    selectedThemas.length === 0 &&
    !searchTerm &&
    !gratisFilter
  ) {
    listFilteredNetworkInformation(Array.from(networks));
    showFullInfoPanel();
    resetFilteredNetworkDropdown();
    return;
  }

  // Otherwise: filter using AND logic
  const filteredNetworks = Array.from(networks).filter((network) => {
    // 1. Gratis
    if (gratisFilter && network.getAttribute("data-themagratis") !== "1") {
      return false;
    }

    // 2. Search term (checks name, body, or tagscategory)
    if (searchTerm) {
      const name = (network.getAttribute("data-name") || "").toLowerCase();
      const body = (network.getAttribute("data-body") || "").toLowerCase();
      let catTags = [];
      try {
        catTags = JSON.parse(network.getAttribute("data-tagscategory") || "[]");
      } catch (e) { }
      const categoryMatch = catTags.some((tag) => tag.toLowerCase().includes(searchTerm));

      if (
        !(name.includes(searchTerm) ||
          body.includes(searchTerm) ||
          categoryMatch)
      ) {
        return false;
      }
    }

    // 3. Tags (Dropdown: matches at least one selected tag)
    if (selectedTags.length > 0) {
      let networkTags = [];
      try {
        networkTags = JSON.parse(network.getAttribute("data-tagswijk") || "[]");
      } catch (e) { }
      const hasTag = selectedTags.every((tag) => networkTags.includes(tag));
      if (!hasTag) return false;
    }

    // 4. Thema (Checkbox: matches at least one selected thema)
    if (selectedThemas.length > 0) {
      let themasList = [];
      try {
        themasList = JSON.parse(network.getAttribute("data-tagsthema") || "[]");
      } catch (e) { }
      const hasThema = selectedThemas.every((thema) => themasList.includes(thema));
      if (!hasThema) return false;
    }

    // All conditions are true
    return true;
  });

  listFilteredNetworkInformation(filteredNetworks);

  // Hide/show panels as in your original code…
  if (filteredNetworks.length === 0) showFullInfoPanel();
};

// helpers for legacy code:
function showFullInfoPanel() {
  const filteredPartnerInformationList = document.getElementById(
    "filtered-network-information-list"
  );
  if (filteredPartnerInformationList) {
    const partnerInformationList = document.getElementById("partner-information-list");
    filteredPartnerInformationList.classList.add("hidden");
    partnerInformationList.classList.remove("hidden");
  }
}
function resetFilteredNetworkDropdown() {
  const buttonElement = document.getElementById("dropdownMenuMap");
  if (buttonElement === null) { return; }
  buttonElement.textContent = "Kies een wijk";
}
// end helpers for legancy code

export const listFilteredNetworkInformation = (listNetworks) => {
  let htmllist = "";
  const filterMapView = [];

  // console.log(listNetworks);

  /** map view: filtered result first network ============ */

  const partnerInformationWrapper = document.getElementById("partner-information");
  const partnerInformation = partnerInformationWrapper
    ? partnerInformationWrapper.querySelector(".splide__list")
    : null;


  if (partnerInformation === null) { return; }

  if (mapSplideInstance) {
    mapSplideInstance.destroy();
    mapSplideInstance = null;
  }
  // Clear existing content (optional, depends on your use case)
  partnerInformation.innerHTML = "";

  if (listNetworks.length === 0) {
    partnerInformation.innerHTML += renderNetworkInformationNoLoca();
  } else {
    listNetworks.forEach((network) => {
      partnerInformation.innerHTML += renderNetworkInformation(network);
    });
  }
  /** end map view: filtered result first network ============ */

  /** list and markers:  ============ */
  listNetworks.forEach((network, index) => {
    // htmllist += renderNetworkInformationList(network, index);
    //push the relevant data to the array so that we can generate a new map view
    filterMapView.push(networkDataAttributeBuilder(network));
  });

  /** end list and markers ============ */

  /** this re-renders the marker on the network map ============ */
  var netwerkMapCanvas = document.getElementById("netwerk-map");

  if (netwerkMapCanvas) {
    // console.log("what", filterMapView);
    netwerkInitMap(filterMapView);
  }
  /** end this re-renders the marker on the network map ============ */

  const partnerInformationList = document.getElementById(
    "partner-information-list"
  );

  const filteredPartnerInformationList = document.getElementById(
    "filtered-network-information-list"
  );

  if (filteredPartnerInformationList) {
    filteredPartnerInformationList.innerHTML = htmllist;
    filteredPartnerInformationList.classList.remove("hidden");
    partnerInformationList.classList.add("hidden");
  }

  slickMap();
};

function slickMap() {
  // console.log("trigger slick");

  if ($('.map-slider').length) {
    mapSplideInstance = new Splide('.map-slider', {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      grid: {
        dimensions: [[2, 2]],
        gap: {
          row: '1em',
          col: '1em'
        }
      },
      autoplay: false,
      interval: 8000,
      pagination: false,
      padding: 0,
      breakpoints: {
        1024: {
          grid: {
            dimensions: [[2, 1]],
            gap: {
              row: '1em',
              col: '1em'
            }
          },
        },
      },
    });

    const counter = document.querySelector('.splide-counter');

    mapSplideInstance.on('mounted move', function () {
      const totalSlides = mapSplideInstance.length;
      const perPage = mapSplideInstance.options.perPage;
      const totalPages = Math.ceil(totalSlides / perPage);

      const currentPage = Math.floor(mapSplideInstance.index / perPage) + 1;

      if (counter) counter.textContent = `${currentPage} van ${totalPages}`;

      var $list = $('.splide__list');
      var $slides = $('.splide__slide');

      // Remove Splide’s auto-added role=presentation on <ul>
      $list.removeAttr('role');

      // Fix roles for each slide
      $slides.each(function (index) {
        $(this)
          .attr('role', 'listitem');
      });
    });

    // mapSplide.mount();
    mapSplideInstance.mount(window.splide.Extensions);
  }
}

export const renderNetworkInformation = (network) => {
  let html = "";
  var name = network.getAttribute("data-name");
  var body = network.getAttribute("data-body");
  var colour = network.getAttribute("data-colour");
  var address = network.getAttribute("data-address");
  var url = network.getAttribute("data-url");
  var isGratis = network.getAttribute("data-themagratis") === "1";
  var tags = [];
  if (network.getAttribute("data-tagswijk") != "") {
    tags = JSON.parse(network.getAttribute("data-tagswijk"));
  } else {
    // tags = "";
  }

  let tagHtml = "";

  if (tags.length > 0) {
    tags.forEach((tag) => {
      tagHtml +=
        '<div class="tag inline-block pt-px pb-1 px-2 rounded-full border text-white dark:text-cirBlack bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">';
      tagHtml += `<span class="text-sm scale-text-150:text-lg scale-text-200:text-[22px] font-degularText uppercase">${tag}</span>`;
      tagHtml += "</div>";
    });
  }

  // html += '<div class="maplist-slick-slider">';
  html +=
    '<li class="splide__slide py-5 lg:p-5 eachCardPartner"><div class="items-center gap-8 kenn">';
  html += `
  <h2
    style="color: ${colour};"
    class="partner-name text-[26px] scale-text-150:text-[30px] scale-text-200:text-[34px] leading-8 font-bold pb-2"
  >${name}</h2>
  ${isGratis ? '<div class="border border-black rounded-full px-4 py-2 mt-2 mb-4 w-fit text-sm">Gratis</div>' : ''}
</div>`;

  html +=
    '<div class="partner-body font-normal pb-4 font-degularText text-lg scale-text-150:text-xl scale-text-200:text-2xl">';
  html += `${body}`;
  html += "</div>";

  html +=
    '<div class="font-degular font-medium text-[18px] scale-text-150:text-[20px] scale-text-200:text-[24px] not-italic py-4">';
  html += `<div class="partner-address">${address}</div>`;
  html += `</div>`;

  html += `<a
  href="${url}"
  target="_blank"
  rel="noopener noreferrer"
  class="partner-website-button origin-left scale-75 md:scale-100 flex items-center hover-arrow arrow-icon-after-white cursor-pointer hover:no-underline w-fit h-[40px] text-white py-2.5 px-6 rounded-full"
  style="background-color: ${colour};"
  aria-label="Bekijk alles – Link naar ${name}"
>
  Bekijk alles
</a>`;

  html += "</li>";
  return html;
};

export const renderNetworkInformationList = (network, index) => {
  let html = "";
  var name = network.getAttribute("data-name");
  var body = network.getAttribute("data-body");
  var colour = network.getAttribute("data-colour");
  var address = network.getAttribute("data-address");
  var url = network.getAttribute("data-url");
  var tags = [];
  if (network.getAttribute("data-tagswijk") != "") {
    tags = JSON.parse(network.getAttribute("data-tagswijk"));
  } else {
    // tags = "";
  }

  let tagHtml = "";

  if (tags.length > 0) {
    tags.forEach((tag) => {
      tagHtml +=
        '<div class="tag inline-block pt-px pb-1 px-2 rounded-full border text-white dark:text-cirBlack bg-black dark:bg-white border-white dark:border-black relative cursor-pointer">';
      tagHtml += `<span class="text-sm scale-text-150:text-lg scale-text-200:text-[22px] font-degularText uppercase">${tag}</span>`;
      tagHtml += "</div>";
    });
  }

  html += `<div class="flex flex-col justify-between h-full">
        <div>
          <div class="items-center gap-8">
            <h2 class="partner-name text-[26px] scale-text-150:text-[30px] scale-text-200:text-[34px] leading-8 font-degularText font-bold pb-2">
              ${name}
            </h2>
          </div>

          <div class="partner-body font-normal pb-4 font-degularText text-lg scale-text-150:text-xl scale-text-200:text-2xl">
          ${body}
          </div>

          <div class="netwerk-tags">
          ${tagHtml}
          </div>


          <div class="font-degular font-medium text-[18px] scale-text-150:text-[20px] scale-text-200:text-[24px] not-italic py-4">
            <div class="partner-address">${address}</div>
          </div>
        </div>


        <a
          href="${url}"
          target="_blank"
          rel="noopener noreferrer"
          class="partner-website-button origin-left scale-75 md:scale-100 flex items-center hover-arrow arrow-icon-after-white cursor-pointer hover:no-underline w-fit h-[40px] text-white py-2.5 px-6 rounded-full"
          style="background-color: ${colour};"
        >
          Bekijk alles
        </a>

      </div>`;

  return html;
};

export const renderNetworkInformationNoLoca = () => {
  let html = "";

  // html += '<div class="maplist-slick-slider">';
  html +=
    '<div class="py-5 lg:p-5 eachCardPartner"><div class="items-center gap-8 kenn">';
  html += `
  <h2
    class="partner-name text-[26px] text-cirBlack scale-text-150:text-[30px] scale-text-200:text-[34px] leading-8 font-bold pb-2"
  >No Location</h2>`;
  html += `</div>`;

  html += "</div>";
  return html;
};

function initCategorySuggestions() {
  const input = document.getElementById("searchQueryInput");
  const suggestionsBox = document.getElementById("searchSuggestions");
  const networks = document.querySelectorAll(".netwerk-info");

  function getSuggestions() {
    const suggestions = new Map();

    networks.forEach((network) => {
      const title = (network.getAttribute("data-name") || "").trim();
      const rawTags = network.getAttribute("data-tagscategory") || "[]";

      if (title) {
        suggestions.set(`title-${title.toLowerCase()}`, {
          label: title,
          type: "title",
        });
      }

      try {
        const parsedTags = JSON.parse(rawTags);

        parsedTags.forEach((tag) => {
          if (tag && tag.trim()) {
            suggestions.set(`tag-${tag.toLowerCase()}`, {
              label: tag.trim(),
              type: "tag",
            });
          }
        });
      } catch (e) {
        // ignore invalid JSON
      }
    });

    return [...suggestions.values()].sort((a, b) =>
      a.label.localeCompare(b.label)
    );
  }

  const allSuggestions = getSuggestions();

  function hideSuggestions() {
    suggestionsBox.classList.add("hidden");
    suggestionsBox.innerHTML = "";
  }

  function applySuggestion(value) {
    input.value = value;
    sessionStorage.setItem("networksearchtags", value);
    tagsBubble();
    hideSuggestions();
  }

  function showSuggestions(matches) {
    suggestionsBox.innerHTML = "";

    if (!matches.length) {
      hideSuggestions();
      return;
    }

    matches.forEach((itemData) => {
      const item = document.createElement("button");
      item.type = "button";
      item.className =
        "block w-full text-left px-4 py-2 hover:bg-gray-100 first:rounded-t-2xl last:rounded-b-2xl";

      item.innerHTML = `
        <span>${itemData.label}</span>
      `;

      item.addEventListener("mousedown", function (e) {
        e.preventDefault();
        applySuggestion(itemData.label);
      });

      suggestionsBox.appendChild(item);
    });

    suggestionsBox.classList.remove("hidden");
  }

  // To prevent JS error in console.
  if (!input || !suggestionsBox) return;
  
  input.addEventListener("input", function () {
    const value = input.value.trim().toLowerCase();

    if (!value) {
      hideSuggestions();
      return;
    }

    const matches = allSuggestions
      .filter((item) => item.label.toLowerCase().includes(value))
      .slice(0, 8);

    showSuggestions(matches);
  });

  input.addEventListener("focus", function () {
    const value = input.value.trim().toLowerCase();

    if (!value) return;

    const matches = allSuggestions
      .filter((item) => item.label.toLowerCase().includes(value))
      .slice(0, 8);

    showSuggestions(matches);
  });

  input.addEventListener("blur", function () {
    setTimeout(() => {
      hideSuggestions();
    }, 150);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initCategorySuggestions();

  const gratisCheckbox = document.getElementById("thema-gratis");
  if (gratisCheckbox) {
    // Restore gratis filter from sessionStorage
    gratisCheckbox.checked = sessionStorage.getItem("themagratistags") === "1";
    gratisCheckbox.addEventListener("change", function () {
      sessionStorage.setItem("themagratistags", this.checked ? "1" : "");
      lookForFilteredNetworks();
      tagsBubble();
    });
  }
  // Optionally, trigger main filter (so page is correctly filtered on load):
  lookForFilteredNetworks();
});
